module.exports = __webpack_public_path__ + "static/media/playground.ecc16042.png";